const stats = [
  { value: '30+', label: 'Años de experiencia', desc: 'Décadas de conocimiento en el sector de impresión y personalización.' },
  { value: '5+', label: 'Años como empresa', desc: 'Printven LLC establecida y creciendo con clientes satisfechos.' },
  { value: '100%', label: 'Compromiso con calidad', desc: 'Cada proyecto recibe nuestra máxima atención y estándares de calidad.' },
];

const values = [
  { icon: 'ri-medal-line', title: 'Calidad Superior', desc: 'Utilizamos los mejores materiales y tecnologías para garantizar resultados excepcionales en cada pedido.' },
  { icon: 'ri-time-line', title: 'Cumplimiento Puntual', desc: 'Respetamos los tiempos de entrega acordados porque sabemos que tu negocio no puede esperar.' },
  { icon: 'ri-customer-service-2-line', title: 'Atención Personalizada', desc: 'Cada cliente recibe atención dedicada desde la cotización hasta la entrega final del producto.' },
  { icon: 'ri-shield-check-line', title: 'Garantía Total', desc: 'Respaldamos cada producto con nuestra garantía de satisfacción. Tu confianza es nuestra prioridad.' },
];

const ValueSection = () => {
  return (
    <>
      {/* Stats Banner */}
      <section className="py-16 md:py-20 bg-[#0A1628] relative overflow-hidden">
        {/* Decorative dots */}
        <div className="absolute top-0 right-0 w-64 h-64 opacity-5">
          <div className="grid grid-cols-8 gap-4">
            {Array.from({ length: 64 }).map((_, i) => (
              <div key={i} className="w-2 h-2 bg-white rounded-full"></div>
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <span className="text-[#FF6B35] text-sm font-semibold uppercase tracking-widest">Por qué elegirnos</span>
            <h2 className="text-3xl md:text-5xl font-extrabold text-white mt-3">
              Experiencia que Habla por Sí Sola
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center p-6 md:p-8 border border-white/10 rounded-2xl hover:border-[#FF6B35]/40 transition-colors">
                <div className="text-4xl md:text-6xl font-extrabold text-[#FF6B35] mb-3">{stat.value}</div>
                <div className="text-white font-bold text-lg md:text-xl mb-2">{stat.label}</div>
                <p className="text-white/50 text-sm leading-relaxed">{stat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Grid */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-[#FF6B35] text-sm font-semibold uppercase tracking-widest">Nuestros valores</span>
            <h2 className="text-3xl md:text-5xl font-extrabold text-[#0A1628] mt-3 mb-4">
              Calidad, Compromiso y Experiencia
            </h2>
            <p className="text-[#6C757D] text-lg max-w-2xl mx-auto">
              Más de 30 años de experiencia acumulada nos respaldan en cada proyecto que emprendemos.
            </p>
            <div className="w-16 h-1 bg-[#FF6B35] rounded-full mx-auto mt-6"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) => (
              <div key={v.title} className="p-8 rounded-2xl bg-[#F8F9FA] hover:bg-[#0A1628] group transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl mb-5 group-hover:bg-[#FF6B35]/20 transition-colors">
                  <i className={`${v.icon} text-[#FF6B35] text-2xl`}></i>
                </div>
                <h3 className="text-[#0A1628] group-hover:text-white font-bold text-lg mb-3 transition-colors">{v.title}</h3>
                <p className="text-[#6C757D] group-hover:text-white/60 text-sm leading-relaxed transition-colors">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ValueSection;
